import styled from "styled-components";
import { GlobalWrapper } from "shared/Styles/Wrappers";

export const Container = styled(GlobalWrapper)`
  background-color: ${({ color }) => (color ? color : "#fff")};
`;
